import { render, staticRenderFns } from "./IssuePassButton.vue?vue&type=template&id=64af3e18&scoped=true"
import script from "./IssuePassButton.vue?vue&type=script&lang=js"
export * from "./IssuePassButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af3e18",
  null
  
)

export default component.exports